import React, { useState } from 'react';
import { format } from 'date-fns';
import { useDispatch } from 'react-redux';
import { getCateringOrderPdf } from 'redux/catering/actions';
const ReportCard = ({ data, currentPage, setCurrentPage }) => {
  const dispatch = useDispatch();

  const { userCateringOrders, pagination } = data || {};
  const { perPage, totalCount, totalPages } = pagination || {};
  const totalPrice = userCateringOrders?.reduce(
    (sum, item) => sum + item.totalPrice,
    0,
  );

  // Pagination Handlers
  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  return (
    <div>
      {/* Table */}
      <table className="report-table">
        <thead>
          <tr>
            <th> Delivery Date</th>
            <th>Vendor</th>
            {/* <th> Receipts</th> */}
            <th>Total Spend</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {userCateringOrders?.map(item => (
            <tr key={item?.id}>
              <td>
                {format(
                  new Date(item?.orderDateTime),
                  'EEEE, MMMM  do, yyyy, h:mm aaa',
                )}
              </td>
              <td>{item?.chefName}</td>
              {/* <td>N/A</td> */}
              <td>
                {'$' +
                  (item.totalPrice / 100).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 3,
                  }) || '$0.00'}
              </td>
              <td>
                <span className="button-wrapper-report">
                  {' '}
                  <button
                    className="column-action-pdf-button"
                    style={{ marginTop: '2px' }}
                  >
                    <a href={`/chefs/${item.presetSlug}`} target="_blank">
                      View Details
                    </a>
                  </button>
                  <button
                    type="button"
                    className="column-action-pdf-button"
                    onClick={() => {
                      if (item?.id) {
                        dispatch(getCateringOrderPdf(item.id));
                      }
                    }}
                  >
                    Download PDF
                  </button>
                </span>
              </td>
            </tr>
          ))}{' '}
          <tr style={{ fontWeight: 'bold' }}>
            <td colSpan="2">
              <u>Final Total Spend</u>
            </td>
            <td>
              {'$' +
                (totalPrice / 100).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 3,
                }) || '$0.00'}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div className="pagination">
        <button onClick={prevPage} disabled={currentPage === 1}>
          Previous
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button onClick={nextPage} disabled={currentPage === totalPages}>
          Next
        </button>
      </div>
    </div>
  );
};

export default ReportCard;
